export enum BankLineStatus {
  Pending = 'pending',
  Booked = 'booked',
}
